<template>
  <div class="footerbar fr ac jc">
    <div class="footer_cont fr">
      <div class="cont_left">
        <div class="table_box fr afe">
          <table class="white table">
            <tr class="fz18 bold">
              <th>商品分类</th>
              <th>关于合作</th>
              <th>服务与支持</th>
            </tr>
            <tr class="fz14">
              <td>行业分类</td>
              <td>VIP客户注册</td>
              <td>常见问题</td>
            </tr>
            <tr class="fz14">
              <td>特性分类</td>
              <td>服务商注册</td>
              <td>电子资料</td>
            </tr>
          </table>
        </div>
        <div class="left_bottom fz12 fc ac jfe white">
          <p class="mb10">Copyright © mall.beltdance.com, All Rights Reserved.</p>
          <p class="mb10">上海益发物联科技有限公司</p>
        </div>
      </div>
      <div class="cont_right fr ac">
        <div class="right_left">
          <p class="fz18 white bold mb20">联系我们</p>
          <div>
            <p class="fz14 white mb10">地址：上海市松江天马开发区天峰路141号</p>
            <p class="fz14 white mb10">邮编：201603</p>
            <p class="fz14 white mb10">电话：021-57663636 57663696</p>
            <p class="fz14 white mb10">E-mail:efab@efab.com.cn</p>
          </div>
        </div>
        <div class="right_right fc ac jc">
          <img src="/static/imgs/home/Wechat.jpeg" class="img" alt />
          <p class="fz14 white mt10">公众号商城</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {},
  data() {
    return {};
  },
  computed: {},
  created() {},
  mounted() {},
  watch: {},
  methods: {},
  components: {},
};
</script>

<style scoped lang="scss">
.footerbar {
  width: 100%;
  height: 300px;
  background-color: #333333;
  .footer_cont {
    width: 1200px;
    height: 100%;
    .cont_left {
      width: 55%;
      height: 100%;
      .table_box {
        width: 100%;
        height: 70%;
        .table {
          width: 100%;
          height: 45%;
          text-align: center;
        }
      }
      .left_bottom {
        width: 100%;
        height: 30%;
      }
    }
    .cont_right {
      width: 45%;
      height: 100%;
      .right_left {
        width: 70%;
        padding-left: 30px;
        border-left: 2px solid white;
      }
      .right_right {
        width: 30%;
        .img {
          width: 125px;
          height: 125px;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/FooterBar.vue